import React from 'react';

function Play() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M3 0v24l18.857-12z" />
    </svg>
  );
  /* eslint-enable */
}

export default Play;



// WEBPACK FOOTER //
// ./src/common/icons/Play.js